import { num } from "@/lib/sk";

export const VARIANT_LABEL = { normal: "Normal", skift: "Skift", ot50: "50 % overtid", ot100: "100 % overtid" };
export const VARIANT_SHORT = { normal: "Normal", skift: "Skift", ot50: "50 %", ot100: "100 %" };
export const VARIANT_ORDER = ["normal", "skift", "ot50", "ot100"];
export const KIND_LABEL = { pris: "Fast pris", pr_time: "Pr. time", etter_regning: "Etter regning", note: "Etter avtale" };
export const KIND_FILTERS = [["alle", "Alle"], ["pris", "Fast pris"], ["pr_time", "Pr. time"], ["etter_regning", "Etter regning"]];
export const STATUS_LABEL = { bekreftet: "Bekreftet", historisk: "Historisk", demo: "Demo", uavklart: "Uavklart" };
export const VIEWS = [["prisliste", "Prisliste"], ["fag", "Fagområder"], ["anlegg", "Anlegg"]];

const UNIT = { time: "time", stk: "stk", m2: "m²", m: "m", kg: "kg", liter: "l", døgn: "døgn", tømming: "tømming", fat: "fat", punkt: "punkt", måling: "måling", propell: "propell", kWh: "kWh" };
export const unitLabel = (u) => (u ? UNIT[u] || u : "");

/** How a line is priced – honest: an unknown number is never shown as 0. */
export function priceText(line) {
  if (line.price != null) return { main: num(line.price, Number.isInteger(line.price) ? 0 : 2), unit: line.unit ? `/${unitLabel(line.unit)}` : "", kind: "pris" };
  if (line.price_kind === "pr_time") return { main: "Pr. time", unit: "", kind: "pr_time", quiet: true };
  if (line.price_kind === "etter_regning") return { main: "Etter regning", unit: "", kind: "etter_regning", quiet: true };
  if (line.price_kind === "note") return { main: "Etter avtale", unit: "", kind: "note", quiet: true, note: line.note };
  return { main: "–", unit: "", kind: "ukjent", quiet: true };
}

export const minText = (line) => (line.min_qty ? `min. ${num(line.min_qty)} ${unitLabel(line.min_unit || line.unit)}` : null);

export function matchLine(line, q) {
  if (!q) return true;
  const s = q.toLowerCase();
  return [line.description, line.group_label, line.note, line.id, line.unit].some((v) => (v || "").toLowerCase().includes(s));
}

export const matchKind = (line, k) => (!k || k === "alle" ? true : line.price_kind === k);

/** Timepriser as families: one row per service, the four tariffs as columns. */
export function familiesOf(lines) {
  const map = new Map();
  lines.forEach((l) => {
    const key = l.family || l.id;
    const f = map.get(key) || { key, label: l.family_label || l.description, variants: {}, lines: [], order: l.order, usage: 0 };
    f.variants[l.variant || "normal"] = l;
    f.lines.push(l);
    f.usage += l.usage?.cases || 0;
    if (l.variant === "normal") f.label = l.family_label || l.description;
    map.set(key, f);
  });
  return [...map.values()].sort((a, b) => a.order - b.order);
}

export const usageText = (u) => (!u?.cases ? null : `${u.cases} ${u.cases === 1 ? "sak" : "saker"}`);
